import { Link } from 'react-router-dom';
import '../CSS/pages.css';

function Home() {
  return (
    <main>
      <section className="hero">
        <img
          className="hero-image"
          src="/images/dispatch-hero.png"
          alt="Dispatch workspace with route planning screens and a freight truck"
        />
        <div className="hero-overlay" />
        <div className="hero-content">
          <p className="eyebrow">Truck dispatch services</p>
          <h1>Reliable loads, sharper routes, and steady support for carriers.</h1>
          <p className="hero-copy">
            Emmapro Logistix helps owner-operators and carriers stay
            moving with dispatch support built around communication, planning,
            and profitable freight opportunities.
          </p>
          <div className="hero-actions">
            <Link className="primary-action" to="/contact">
              Request a proposal
            </Link>
            <Link className="secondary-action" to="/about">
              Learn more
            </Link>
          </div>
        </div>
      </section>

      <section className="service-band">
        <div className="service-intro">
          <p className="eyebrow">Dispatch support</p>
          <h2>Built for day-to-day freight decisions.</h2>
        </div>
        <div className="service-grid">
          <article className="service-card">
            <span>01</span>
            <h3>Owner operator</h3>
            <p>
              Dispatch support for single-truck operators who need load
              sourcing, broker communication, and route planning without losing
              control of the business.
            </p>
            <Link to="/services/owner-operator">View service</Link>
          </article>
          <article className="service-card">
            <span>02</span>
            <h3>Carrier dispatch support</h3>
            <p>
              Help coordinate drivers, pickup details, delivery windows, rate
              confirmations, and weekly freight planning for growing carrier
              operations.
            </p>
            <Link to="/services/small-fleet-carrier-dispatch-support">
              View service
            </Link>
          </article>
          <article className="service-card">
            <span>03</span>
            <h3>Dedicated lanes</h3>
            <p>
              Route-focused dispatch planning for carriers who want consistent
              lanes, better backhaul options, and dependable weekly movement.
            </p>
            <Link to="/services/dedicated-lanes-routes">View service</Link>
          </article>
          <article className="service-card">
            <span>04</span>
            <h3>Over-the-Road</h3>
            <p>
              OTR dispatch support for carriers ready to run farther, evaluate
              stronger freight options, and keep communication tight from pickup
              through delivery.
            </p>
            <Link to="/services/over-the-road">View service</Link>
          </article>
        </div>
      </section>
    </main>
  );
}

export default Home;
